import { isMobile } from "../../common/Helper"
import BreadCrumb from "../../components/BreadCrumb"
import DreamExperienceSection from "../../components/DreamExperienceSection"
import LocationDescription from "../../components/LocationDescription"
import LocationMainBannerSection from "../../components/LocationMainBannerSection"
import LocationVacationDestination from "../../components/LocationVacationDestination"
import MapboxNew from "../../components/MapboxNew"
import NearbyAttractions from "../../components/NearbyAttractions"
import TourStyle from "../../components/TourStyle"
import VacationDestination from "../../components/VacationDestination"
import Welcome from "../../components/Welcome"

const Index = ({
    productList,
    isLoading, tourStyle,
    locationDetail,
    nextLocations,
    // nextTheme,
    attractionNearNextPageUrl,
    onClickLoadMore,
    isAttractionNearLoading,
    isTourStyleLoading,
    tourStyleNextPageUrl,
    isNextVacationLoading,
    nextLocationNextPageUrl,

    handleKeyUp,
    searchValue,
    setSearchValue,
    onClickReset,
    isSearchLoading,
    productsSuggetion,
    activitiesSuggetion,
    destinationSuggetions,
    onClickProduct,
    onClickDestination,
    onClickActivity,
    breadcrumbList,
    isProductsLoading,
    isNextLoading,
    isStyleLoading
    // toggleMap,
    // mapLoaded,

}) => {
    return (
        <>
            <LocationMainBannerSection
                isLoading={isLoading}
                locationDetail={locationDetail}
                handleKeyUp={handleKeyUp}
                searchValue={searchValue}
                setSearchValue={setSearchValue}
                onClickReset={onClickReset}
                isSearchLoading={isSearchLoading}
                productsSuggetion={productsSuggetion}
                activitiesSuggetion={activitiesSuggetion}
                destinationSuggetions={destinationSuggetions}
                onClickProduct={onClickProduct}
                onClickDestination={onClickDestination}
                onClickActivity={onClickActivity}
            />
            <div className="container">
                <BreadCrumb list={breadcrumbList} />
            </div>
            <NearbyAttractions
                productList={productList}
                isLoading={isProductsLoading}
                title={'Explore tours'}
                attractionNearNextPageUrl={attractionNearNextPageUrl}
                onClickLoadMore={onClickLoadMore}
                isAttractionNearLoading={isAttractionNearLoading}
                extClass="location-page-exp"
            />
            {
                nextLocations.length > 0 &&
                <LocationVacationDestination
                    nextLocations={nextLocations}
                    locationDetail={locationDetail}
                    isLoading={isNextLoading}
                    title={"Top Attraction In/From " + (locationDetail?.children_count > 0 ? locationDetail?.name : locationDetail?.parent?.name)}
                    isNextVacationLoading={isNextVacationLoading}
                    nextLocationNextPageUrl={nextLocationNextPageUrl}
                    onClickLoadMore={onClickLoadMore}
                />
            }

            {
                tourStyle && tourStyle?.length > 0 &&
                <TourStyle
                    tourStyle={tourStyle}
                    isTourStyleLoading={isTourStyleLoading}
                    tourStyleNextPageUrl={tourStyleNextPageUrl}
                    onClickLoadMore={onClickLoadMore}
                    page={'LOCATION'}
                    locationDetail={locationDetail}
                />
            }
            <DreamExperienceSection />
            {
                locationDetail?.description &&
                <LocationDescription
                    name={locationDetail?.name}
                    description={isMobile()?locationDetail?.mobile_description :locationDetail?.description}
                // latitude={locationDetail.latitude}
                // longitude={locationDetail.longitude}
                // zoom_level={locationDetail.zoom_level}
                // mapLoaded={mapLoaded}
                // toggleMap={toggleMap}
                // map_style={locationDetail.map_style}
                />
            }


            {/* <div className="mainContentBox mt-5 mb-4">
                {
                    locationDetail.latitude &&
                    <div className="clickMap">
                        <button className="btn btnMap" type='button' onClick={toggleMap}>Show Me In The Map</button>
                        <div className="mapBox mt-3" style={{
                            opacity: 0,
                            maxHeight: "0",
                            overflow: "hidden",
                            transition: "opacity 0.5s ease, max-height 0.5s ease",
                        }}>
                            {
                                // mapLoaded &&
                                <MapboxNew
                                    lat={Number(locationDetail.latitude)}
                                    lng={Number(locationDetail.longitude)}
                                    zoom={locationDetail.zoom_level}
                                    mapLoaded={mapLoaded}
                                />
                            }
                        </div>
                    </div>
                }
            </div> */}

        </>

    )

}
export default Index